import { CellFormatterService, TableOptions } from '../common/datatable';
import { AuditClassFactory } from './audit-class-maker';

export class AuditSettingsTaskOutputPoolsTableOptions {

    options: TableOptions;

    constructor(private cellFormatterService: CellFormatterService) {
        this.options = this.getDefaultOptions();
    }

    getDefaultOptions(): TableOptions {

        return {
            csvFileName: 'settings-task-output-pools-audit.csv',
            enableDetailColumn: false,
            enableDraggable: false,
            enableSelectable: false,
            enableAuditColumns: false,
            columns: [
                {
                    displayName: 'Type',
                    field: 'UpdateType',
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified Fields',
                    field: 'ModifiedFields',
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Date',
                    field: 'ModifiedDate',
                    formatter: this.cellFormatterService.dateTimeUTCFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Modified By',
                    field: 'ModifiedBy',
                    formatter: this.cellFormatterService.userNameFormatter,
                    cellClass: AuditClassFactory.createDeletedClass,
                },
                {
                    displayName: 'Pool Name',
                    field: 'PoolName',
                    formatter: this.cellFormatterService.createAuditColumnFormatter('PoolName',  'PoolName'),
                    cellClass: AuditClassFactory.createCellClass('poolname'),
                }
            ]
        };
    }
}
